import { render, staticRenderFns } from "./PlanListSuggestPopup.vue?vue&type=template&id=13251f52&scoped=true&"
import script from "./PlanListSuggestPopup.vue?vue&type=script&lang=ts&"
export * from "./PlanListSuggestPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PlanListSuggestPopup.vue?vue&type=style&index=0&id=13251f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13251f52",
  null
  
)

export default component.exports